

exports.__esModule = true;
exports.decodeEntities = exports.hasAddressChanged = exports.pxpTreatments = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _index = require('xo-device-info/dist/index');

// Flags for single password
function getSinglePassword(country) {
    if (country !== 'US' && _index.$DeviceInfo.isDevice()) {
        return _angular.$q.when(true);
    }

    return (0, _squid.$pxp)('xoon_single_password', { 'ctx.COUNTRY': country }, '(xoon_single_password_)(.*)').then(function (result) {
        if (result && result.treatment_name === 'xoon_single_password_test') {
            return true;
        }
        return false;
    });
}

var pxpTreatments = {
    getSinglePassword: getSinglePassword
};

function isString(value) {
    return angular.isString(value) || value instanceof String;
}

function areAddressFieldsEqual(addressElement1, addressElement2) {
    if (addressElement1 === addressElement2) {
        return true;
    }
    if (addressElement1 === undefined && addressElement2 === '' || addressElement1 === '' && addressElement2 === undefined) {
        return true;
    }
    if (isString(addressElement1) && isString(addressElement2)) {
        return addressElement1.toUpperCase() === addressElement2.toUpperCase();
    }
    return false;
}

var hasAddressChanged = function hasAddressChanged(address1, address2) {
    var fieldsToCompare = [[address1.line1, address2.line1], [address1.line2, address2.line2], [address1.city, address2.city], [address1.state, address2.state], [address1.postal_code, address2.postal_code], [address1.country_code, address2.country]];
    for (var i = 0; i < fieldsToCompare.length; i++) {
        if (!areAddressFieldsEqual(fieldsToCompare[i][0], fieldsToCompare[i][1])) {
            return true;
        }
    }
    return false;
};

function decodeEntities(input) {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }
    var converter = window[ENTITY_ELEM];
    converter.innerHTML = input;
    return converter.innerText || converter.text || converter.textContent;
}

exports.pxpTreatments = pxpTreatments;
exports.hasAddressChanged = hasAddressChanged;
exports.decodeEntities = decodeEntities;


_angular.$q;

_squid.$pxp;

_index.$DeviceInfo;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/lib/util.js
// module id = ./components/xo-guest-components/src/lib/util.js
// module chunks = 1